import React from 'react';
import { ListColumnType, ListFilterType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';

// Rename the name of the function:
const ServiceList: React.FC = () => {

    // Specify the options of this list:
    const query = {
        endpoint: 'get_service_list',
        defaultParams: { 'is_active': true },
        object: 'service'
    }
    const objectName = 'service.general.object_name'
    const showSearch = true
    const showDeleteOrDeactivate = 'flag_deactivated'

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = false

    // Specify form, detail modal or detailpage for this list
    const formModal = <></>;
    const onRowClick = 'detailModal'

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '7fr', field: 'name', label: 'service.general.name_label' },
        { width: '5fr', field: 'number', label: 'service.general.number_label' },
        { width: '8fr', field: 'description', label: 'service.general.description_label' },
        { width: '4fr', field: 'sale_price', label: 'service.general.sale_price_label' },
    ];

    // Specify the filters of this list:
    const filters: ListFilterType[] = [
        {
            id: 'active',
            label: 'service.general.active_services_label',
            params: { 'is_active': true }
        },
        {
            id: 'inactive',
            label: 'service.general.inactive_services_label',
            params: { 'is_active': false }
        }
    ]

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            filters={filters}
            columns={columns}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            formModal={formModal}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
        />
    );
};

export default ServiceList;